// extracted by mini-css-extract-plugin
export default {"loader_container":"MediumLoader_loader_container__K8SbJ","loader":"MediumLoader_loader__+MVcK","spinner-c7wet2":"MediumLoader_spinner-c7wet2__98sxb"};